import React from 'react';
import { useRemoteShare } from './lib/remote-share-context';
import RemoteLandmarksTool from './RemoteLandmarksTool';
import RemoteGoniometerTool from './RemoteGoniometerTool';

/**
 * VGon 3 layout for both modes (shared window left, controls right). Both tools stay mounted and
 * are only hidden when inactive, so switching modes keeps unsaved work and never re-shares.
 */
export default function RemoteToolPanel() {
  const { tool } = useRemoteShare();
  return (
    <>
      <div className={tool === 'landmarks' ? 'h-full' : 'hidden'}>
        <RemoteLandmarksTool />
      </div>
      <div className={tool === 'goniometer' ? 'h-full' : 'hidden'}>
        <RemoteGoniometerTool />
      </div>
    </>
  );
}
